module.exports = __webpack_public_path__ + "img/THOI_TRANG_MY_PHAM.32bd1d61.svg";